import React, { useState, useContext, useRef } from 'react'
import QuotationProductCard from '../../components/quotation-product-card'
import QuotationCustomCard from '../../components/quotation-custom-card'
import './style.css'
import BackButton from '../../components/back-button'

import { Button, Empty, Form, Input, message } from 'antd'
import { MainStore } from '../../utils/store/context'
import ApiService from '../../utils/apiServices'
import { quotation } from '../../utils/schemas'
import TextArea from 'antd/es/input/TextArea'
import Loading from '../../components/loading'


export default function Quotation() {

    const { setCart } = useContext(MainStore)

    const { create } = ApiService()

    const formRef = useRef()

    const [carts, setCarts] = useState(localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")) : [])
    const [submitData, setSubmitData] = useState({ ...localStorage.getItem("temp_quotation_data") ? JSON.parse(localStorage.getItem("temp_quotation_data")) : [] })
    const [isLoading, setIsLoading] = useState(false)


    const [messageApi, contextHolder] = message.useMessage();

    function onAddCustomCart() {
        let temp_cart = [...carts]

        if (temp_cart.length >= 5) {
            messageApi.error("จำนวนสินค้าในตะกร้าต้องไม่เกิน 5 ชิ้น / 1 ใบเสนอราคา.");
        } else {
            temp_cart.push({
                type: 2,
                "detail": "",
                "is_pined": false,
                "is_hilight": false,
                "name": "",
                "qty": 0,
                product_detail: "",
                product_qty: 0,
                product_logo_count: "",
                product_logo: "",
                product_image: "",
                "is_active": "true",
                "price": 0,
                id: parseInt(1 + Math.random() * 99999)
            })

            localStorage.setItem("cart", JSON.stringify(temp_cart))
            setCarts(temp_cart)
            setCart(temp_cart.length)
        }
    }

    function onRemoveFromCart(id) {
        let temp_cart = [...carts]
        let new_cart = []

        temp_cart.forEach((item) => {
            if (id !== item.id) {
                new_cart.push(item)
            }
        })

        localStorage.setItem("cart", JSON.stringify(new_cart))
        setCarts(new_cart)
        setCart(new_cart.length)
    }

    function onChangeData(key, value, index = null) {
        let tempData = { ...submitData, cart_items: carts }

        if (index !== null)
            tempData.cart_items[index][key] = value
        else
            tempData[key] = value

        setSubmitData(tempData)
        setCarts(tempData.cart_items)
        localStorage.setItem("cart", JSON.stringify(tempData.cart_items))
        localStorage.setItem("temp_quotation_data", JSON.stringify(tempData))
    }


    function handleSubmitData() {
        setIsLoading(true)
        create(quotation, submitData).then((response) => {
            if (response.code === 201) {
                localStorage.removeItem("cart")
                localStorage.removeItem("temp_quotation_data")
                setSubmitData(null)
                setCarts([])
                setIsLoading(false)

                setCart(0)

                messageApi.success("ขอใบเสนอราคาเรียบร้อยแล้ว เราจะติดต่อกลับหาคุณโดยเร็วที่สุด.");
            } else {
                messageApi.error("ขอใบเสนอราคาไม่สำเร็จ กรุณาลองใหม่อีกครั้ง.");
            }

        }).catch((err) => {
            messageApi.error("ขอใบเสนอราคาไม่สำเร็จ กรุณาลองใหม่อีกครั้ง.");
        })
    }

    return (
        <>
            {contextHolder}
            {isLoading ? <Loading description={"กำลังส่งขอใบเสนอราคา"} /> :
                <div>
                    <div style={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
                        <BackButton />
                    </div>
                    <div className='quotation-form'>
                        <h1 style={{ textAlign: 'center' }}>แบบฟอร์มขอราคา</h1>
                        <div style={{ textAlign: 'center', fontSize: 'clamp(16px, 2.5vw, 20px)' }}>
                            <p>สอบถามโดยตรงที่ 02-891-3300, <br />081-845-2288 <br />2288@bangkokgift.net</p>
                        </div>
                        <div className="quotation-container" style={{ padding: 20 }}>
                            <p style={{
                                fontSize: '26px',
                                textAlign: 'center',
                                padding: '10px 30px',
                                borderRadius: '50px',
                                fontWeight: "bold",
                                marginTop: '0px',
                                minWidth: "60%",
                                marginBottom: 10,

                            }}>สินค้าที่เลือกเพื่อขอใบเสนอราคา</p>
                            <Form onFinish={() => handleSubmitData()} layout="vertical" ref={formRef}>
                                {carts?.length > 0 ? carts?.map((item, index) => {
                                    return item.type === 1
                                        ? <QuotationProductCard index={index} onChangeData={onChangeData} onRemove={onRemoveFromCart} data={item} key={index} name={item?.name} image={item?.images[0]} navigate_to={`/products/${item?.category_id}/${item?.tag_id}/${item?.id}`} />
                                        : <QuotationCustomCard index={index} onChangeData={onChangeData} onRemove={onRemoveFromCart} data={item} key={index} />
                                }) : <div style={{ padding: "30px 50px" }}>
                                    <Empty description={
                                        <div style={{ fontSize: 16 }}>
                                            <div style={{ fontSize: 20 }}>ไม่มีสินค้าในตะกร้า</div>
                                            กรุณา <b style={{ color: "rgb(218, 24, 99)" }}>เลือกสินค้าใส่ตะกร้า</b> หรือ <b style={{ color: "rgb(218, 24, 99)" }}>เพิ่มสินค้าด้วนตนเอง</b> ก่อนทำการขอใบเสนอราคา
                                        </div>} />
                                </div>}

                                {carts?.length > 0 ? <div className='form-quotation-container'>
                                    <button onClick={onAddCustomCart} style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "10px",
                                        backgroundColor: "#da1863",
                                        color: "white",
                                        fontWeight: "bold",
                                        border: "none",
                                        borderRadius: "15px",
                                        padding: "10px",
                                        cursor: "pointer",
                                        width: "100%",
                                        textAlign: "center",
                                        marginTop: 15,
                                    }}>
                                        <div style={{
                                            backgroundColor: "white",
                                            borderRadius: "50%",
                                            width: "28px",
                                            height: "28px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#c42f55",
                                            fontSize: "24px",
                                            fontWeight: "bold"
                                        }}>
                                            +
                                        </div>
                                        <h1 style={{ margin: '0px', fontSize: 'clamp(16px, 2.5vw, 20px)' }}>เพิ่มสินค้าด้วยตนเอง</h1>
                                    </button>
                                    <div style={{
                                        textAlign: 'start',
                                        padding: 20
                                    }}>
                                        <Form.Item
                                            initialValue={submitData?.client_name}
                                            style={{ marginTop: -10 }}
                                            name="client_name"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "กรุณากรอก 'ชื่อของคุณ'",
                                                },
                                            ]}
                                            label={<p style={{ fontSize: 'clamp(16px, 2.5vw, 20px)', marginBottom: '0px', margin: '15px 0px 15px 0px' }}>ชื่อของคุณ (Your Name)</p>}
                                        >
                                            <Input value={submitData?.client_name} onChange={(e) => onChangeData("client_name", e.target.value)} style={{
                                                width: '100%',
                                                padding: '10px 15px',
                                                borderRadius: '15px',
                                                border: '2px solid #fd0088',
                                                backgroundColor: ' rgb(243, 224, 238, 0)',
                                                fontSize: '16px',
                                                outline: 'none',
                                                marginTop: -20
                                            }} placeholder="กรอกชื่อของคุณ" />
                                        </Form.Item>
                                        <Form.Item
                                            initialValue={submitData?.client_company}
                                            style={{ marginTop: -20 }}
                                            name="client_company"
                                            label={<p style={{ fontSize: 'clamp(16px, 2.5vw, 20px)', marginBottom: '0px', margin: '15px 0px 15px 0px' }}>บริษัท (Company) </p>}
                                        >

                                            <Input value={submitData?.client_company} onChange={(e) => onChangeData("client_company", e.target.value)} style={{
                                                width: '100%',
                                                padding: '10px 15px',
                                                borderRadius: '15px',
                                                border: '2px solid #fd0088',
                                                backgroundColor: ' rgb(243, 224, 238, 0)',
                                                fontSize: '16px',
                                                outline: 'none',
                                                marginTop: -20
                                            }} type="text" placeholder="" />
                                        </Form.Item>
                                        <Form.Item
                                            initialValue={submitData?.client_email}
                                            style={{ marginTop: -10 }}
                                            name="client_email"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "กรุณากรอก 'อีเมลล์ของคุณ'",
                                                },
                                            ]}
                                            label={<p style={{ fontSize: 'clamp(16px, 2.5vw, 20px)', marginBottom: '0px', margin: '15px 0px 15px 0px' }}>อีเมลล์ของคุณ (Your Email)</p>}
                                        >
                                            <Input value={submitData?.client_email} onChange={(e) => onChangeData("client_email", e.target.value)} style={{
                                                width: '100%',
                                                padding: '10px 15px',
                                                borderRadius: '15px',
                                                border: '2px solid #fd0088',
                                                backgroundColor: ' rgb(243, 224, 238, 0)',
                                                fontSize: '16px',
                                                outline: 'none',
                                                marginTop: -20
                                            }} type="text" placeholder="" />
                                        </Form.Item>

                                        <Form.Item
                                            initialValue={submitData?.client_phone}
                                            style={{ marginTop: -10 }}
                                            name="client_phone"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "กรุณากรอก 'เบอร์ติดต่อกลับ'",
                                                },
                                            ]}
                                            label={<p style={{ fontSize: 'clamp(16px, 2.5vw, 20px)', marginBottom: '0px', margin: '15px 0px 15px 0px' }}>เบอร์ติดต่อกลับ (Your Phone)</p>}
                                        >
                                            <Input onChange={(e) => onChangeData("client_phone", e.target.value)} style={{
                                                width: '100%',
                                                padding: '10px 15px',
                                                borderRadius: '15px',
                                                border: '2px solid #fd0088',
                                                backgroundColor: ' rgb(243, 224, 238, 0)',
                                                fontSize: '16px',
                                                outline: 'none',
                                                marginTop: -20
                                            }} type="text" placeholder="" />
                                        </Form.Item>

                                        <Form.Item
                                            initialValue={submitData?.client_line}
                                            style={{ marginTop: -10 }}
                                            name="client_line"

                                            label={<p style={{ fontSize: 'clamp(16px, 2.5vw, 20px)', marginBottom: '0px', margin: '15px 0px 15px 0px' }}>ไอดีไลน์ (LINE ID) </p>}
                                        >
                                            <Input value={submitData?.client_line} onChange={(e) => onChangeData("client_line", e.target.value)} style={{
                                                width: '100%',
                                                padding: '10px 15px',
                                                borderRadius: '15px',
                                                border: '2px solid #fd0088',
                                                backgroundColor: ' rgb(243, 224, 238, 0)',
                                                fontSize: '16px',
                                                outline: 'none',
                                                marginTop: -20
                                            }} type="text" placeholder="" />
                                        </Form.Item>


                                        <Form.Item
                                            initialValue={submitData?.client_detail}
                                            style={{ marginTop: -10 }}
                                            name="client_detail"
                                            // rules={[
                                            //     {
                                            //         required: true,
                                            //         message: "กรุณากรอก 'อีเมลล์ของคุณ'",
                                            //     },
                                            // ]}
                                            label={<p style={{ fontSize: 'clamp(16px, 2.5vw, 20px)', marginBottom: '0px', margin: '15px 0px 15px 0px' }}>รายละเอียดเพิ่มเติม <b> <b>(เช่น ต้องการสินค้าภายในวันที่ DD/MM/YYYY, จัดส่งจังหวัด XXXX)</b></b></p>}
                                        >
                                            <TextArea value={submitData?.client_detail} onChange={(e) => onChangeData("client_detail", e.target.value)} style={{
                                                width: '100%',
                                                minHeight: '200px',
                                                padding: '10px 15px',
                                                borderRadius: '15px',
                                                border: '2px solid #fd0088',
                                                backgroundColor: ' rgb(243, 224, 238, 0)',
                                                fontSize: '16px',
                                                outline: 'none',
                                            }} type="text" placeholder="" />
                                        </Form.Item>




                                    </div>
                                    <Form.Item>
                                        <Button htmlType="submit" style={{
                                            width: '100%',
                                            padding: 10,
                                            borderRadius: '15px',
                                            border: 'none',
                                            backgroundColor: '#da1863',
                                            color: '#fff',
                                            margin: '10px 0vw',
                                            height: 45
                                        }}>
                                            <h1 style={{ margin: 0, fontSize: 'clamp(16px, 2.5vw, 20px)' }}>ขอใบเสนอราคา</h1>
                                        </Button>
                                    </Form.Item>

                                </div> : <div className='form-quotation-container'>
                                    <button onClick={onAddCustomCart} style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "10px",
                                        backgroundColor: "#da1863",
                                        color: "white",
                                        fontWeight: "bold",
                                        border: "none",
                                        borderRadius: "50px",
                                        padding: "10px",
                                        cursor: "pointer",
                                        width: "100%",
                                        textAlign: "center",
                                        marginTop: 15,
                                        marginBottom: 40,
                                    }}>
                                        <div style={{
                                            backgroundColor: "white",
                                            borderRadius: "50%",
                                            width: "28px",
                                            height: "28px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#c42f55",
                                            fontSize: "24px",
                                            fontWeight: "bold"
                                        }}>
                                            +
                                        </div>
                                        <h1 style={{ margin: '0px', fontSize: 'clamp(16px, 2.5vw, 20px)' }}>เพิ่มสินค้าด้วยตนเอง</h1>
                                    </button></div>}
                            </Form>
                        </div>
                    </div>
                </div >}
        </>
    )
}
